export const accountsKeys = {
  info: 'accounts-info' as const,
  rests: 'accounts-rests-in-base-asset' as const,
};
